module.exports = __webpack_public_path__ + "img/jiabanshenqing.b86acf89.png";